var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVendorr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_56005_18774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7216 6.855L10.3466 0.605C10.1366 0.465 9.86325 0.465 9.65325 0.605L0.278249 6.855C0.049082 7.0075 -0.0525847 7.2925 0.026582 7.55583C0.105749 7.81917 0.349082 8 0.624915 8H1.66658V19.6667C1.66658 20.1267 2.03992 20.5 2.49992 20.5H3.33325V11.125C3.33325 10.7808 3.61492 10.5 3.95825 10.5H16.0416C16.3857 10.5 16.6666 10.7808 16.6666 11.125V20.5H17.4999C17.9599 20.5 18.3333 20.1267 18.3333 19.6667V8H19.3749C19.6507 8 19.8932 7.82 19.9732 7.55583C20.0533 7.29167 19.9508 7.0075 19.7216 6.855Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.70703 16.334V16.959C7.70703 17.304 7.42703 17.584 7.08203 17.584C6.73703 17.584 6.45703 17.304 6.45703 16.959V16.334H4.9987C4.7687 16.334 4.58203 16.5207 4.58203 16.7507V20.084C4.58203 20.314 4.7687 20.5007 4.9987 20.5007H9.16536C9.39536 20.5007 9.58203 20.314 9.58203 20.084V16.7507C9.58203 16.5207 9.39536 16.334 9.16536 16.334H7.70703Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.543 16.334V16.959C13.543 17.304 13.263 17.584 12.918 17.584C12.573 17.584 12.293 17.304 12.293 16.959V16.334H10.8346C10.6046 16.334 10.418 16.5207 10.418 16.7507V20.084C10.418 20.314 10.6046 20.5007 10.8346 20.5007H15.0013C15.2313 20.5007 15.418 20.314 15.418 20.084V16.7507C15.418 16.5207 15.2313 16.334 15.0013 16.334H13.543Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.625 11.334V11.959C10.625 12.304 10.345 12.584 10 12.584C9.655 12.584 9.375 12.304 9.375 11.959V11.334H7.91667C7.68667 11.334 7.5 11.5207 7.5 11.7507V15.084C7.5 15.314 7.68667 15.5007 7.91667 15.5007H12.0833C12.3133 15.5007 12.5 15.314 12.5 15.084V11.7507C12.5 11.5207 12.3133 11.334 12.0833 11.334H10.625Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56005_18774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorr);
export default __webpack_public_path__ + "static/media/Vendorr.882f09cb627cc707a1c9b25b77bd9331.svg";
export { ForwardRef as ReactComponent };